import { Box, Divider, Fade, Flex, Hide, Show } from "@chakra-ui/react"
import { useRouter } from "next/router"
import { pages } from "../../../common/constants/constants"
import { campaignTypes } from "../../../common/constants/search-constants"
import { useGetNovelties } from "../../../common/hooks/queries"
import { useBrandedTranslation } from "../../../common/hooks/useBrandedTranslation"
import { getCampaignItems } from "../../../common/utils/search-utils"
import { CarouselTiles } from "../../shared/CarouselTiles"
import { ChakraNextLinkButton } from "../../shared/ChakraNextLinkButton"
import { CArrowRight } from "../../shared/Icons"
import Loader from "../../shared/Loader"
import { SectionTitle } from "../../shared/SectionTitle"

const Novelties = () => {
  const { t } = useBrandedTranslation()
  const {
    locale,
    query: { brand },
  } = useRouter()
  const { data } = useGetNovelties(locale, String(brand))

  const campaignItems = getCampaignItems(data, campaignTypes.HOME_NOVELTIES)

  return (
    <Box as="section">
      {!data ? (
        <Loader mt={{ base: "10", sm: "16", md: "20" }} />
      ) : (
        !!campaignItems.length && (
          <>
            <Fade in={!!campaignItems.length}>
              <Divider mt={{ base: "10", sm: "16", md: "20" }} mb={{ base: "12", md: "16" }} />
              <Box>
                <Flex justify="space-between" align="center" mb="6">
                  <SectionTitle title={t("new-release-tile-title")} mb="0" />
                  <Show above="xs">
                    <ChakraNextLinkButton
                      label={t("nav-see-all")}
                      color="black"
                      leftIcon={<CArrowRight w="5" h="4" />}
                      iconSpacing="2.5"
                      href={`/${pages.NOVELTIES}`}
                    />
                  </Show>
                </Flex>
                <CarouselTiles items={campaignItems} />
                <Hide above="xs">
                  <ChakraNextLinkButton
                    label={t("nav-see-all")}
                    color="black"
                    border="1px solid"
                    variant="secondary"
                    width="100%"
                    mt="2"
                    href={`/${pages.NOVELTIES}`}
                  />
                </Hide>
              </Box>
            </Fade>
          </>
        )
      )}
    </Box>
  )
}

export default Novelties
